import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { SPTInstructionDispatcher } from "./Variable";

export interface SPTInstructionStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any;
    hasCashIsa?: boolean;
}

export class SPTInstructionStatic extends BaseStore<SPTInstructionStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(SPTInstructionDispatcher, (actionData) => this.onSPTInstructionStoreResponse(actionData));
    }

    public getLastResult(): SPTInstructionStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }
    public getHasCashIsa() {
        return this.getState().hasCashIsa;
    }
    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): SPTInstructionStaticState {
        return { actionType: ActionType.Loading, data: null,hasCashIsa:false };
    }

    private onSPTInstructionStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Update:
                    this.setState({ actionType: actionData.actionType, hasCashIsa: actionData.payload });
                    break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
